import React from 'react';
import { BuilderWizardProvider } from './BuilderWizardProvider';
import SubmissionEditor from './SubmissionEditor/SubmissionEditor';

const BuilderWizard = () => {

  return (
    <BuilderWizardProvider>
      <div style={{ textAlign: 'center' }}>
        <SubmissionEditor />
      </div>
    </BuilderWizardProvider>
  );
}

export default BuilderWizard;